// extracted by mini-css-extract-plugin
export default {"dropdown":"SchemePicker_dropdown__osgik","toggle":"SchemePicker_toggle__fnRb2"};